import { ReactNode } from "react";
import { Portal as ReactPortal } from "react-portal";

export default function Portal({ children }: { children: ReactNode }) {
  return (
    <ReactPortal>
      <div>{children}</div>
    </ReactPortal>
  );
}
